import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
export const tableColumns: ColumnDef<any>[] = [
  {
    accessorKey: 'userId',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-subtle rounded me-2">
            <FeatherIcon icon="file" size={16} className="text-primary-dark" />
          </div>
          <span>User ID</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { userId, id } = original.user ? original.user : { userId: '' };
      return (
        <div className="d-flex align-items-center">
          <Link to={'/users/' + id + '/details'} className="fs-8 fw-bold">
            {userId}
          </Link>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 border-start border-end border-translucent ps-0'
      },
      cellProps: {
        className:
          'ps-4 border-start border-end border-translucent white-space-nowrap ps-0'
      }
    }
  },
  {
    accessorKey: 'fromUserId',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-subtle rounded me-2">
            <FeatherIcon icon="file" size={16} className="text-primary-dark" />
          </div>
          <span>From User ID</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { fromUser } = original;
      return (
        <div className="d-flex align-items-center">
          <div>{fromUser ? fromUser.userId : ''}</div>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 border-start border-end border-translucent ps-0'
      },
      cellProps: {
        className:
          'ps-4 border-start border-end border-translucent white-space-nowrap ps-0'
      }
    }
  },
  {
    accessorKey: 'amount',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <div className="px-1 py-1 bg-primary-subtle rounded me-2">
            <FeatherIcon
              icon="dollar-sign"
              size={16}
              className="text-primary-dark"
            />
          </div>
          <span>USD Amount</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { amount } = original;
      return <>{amount}</>;
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'rewardType',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <span>Reward Type</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { rewardType } = original;
      return (
        <div className="d-flex align-items-center">
          <span className="fw-semibold">{rewardType}</span>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  },
  {
    accessorKey: 'rewardIdentity',
    header: () => {
      return (
        <div className="d-inline-flex flex-center">
          <span>Reward Identity</span>
        </div>
      );
    },
    cell: ({ row: { original } }) => {
      const { rewardIdentity } = original;
      return (
        <div className="d-flex align-items-center">
          <span className="fw-semibold">{rewardIdentity}</span>
        </div>
      );
    },
    meta: {
      headerProps: {
        style: { width: 'auto' },
        className: 'ps-4 pe-5 border-end border-translucent'
      },
      cellProps: {
        className:
          'white-space-nowrap fw-semibold ps-4 border-end border-translucent'
      }
    }
  }
];

const ReferralPointsRewardTable = () => {
  return (
    <div className="border-top border-translucent">
      <AdvanceTable
        tableProps={{ className: 'phoenix-table fs-9' }}
        rowClassName="hover-actions-trigger btn-reveal-trigger"
      />
      <AdvanceTableFooter pagination className="py-4" />
    </div>
  );
};

export default ReferralPointsRewardTable;
